module.exports = __webpack_public_path__ + "img/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.85de2d38.png";